import CONSTANTS from "../../CONSTANTS"
import API from "../../methods/API"
import emailConfig from "./emailConfigs"
// import EMAIL_FORMATS from "./emailFormats"


const emailModals = {

    replaceContent(emailText, form, selectedSpare, user = {}) {
        const { LANGUAGES, LANGUAGE_KEYS } = emailConfig
        const {
            // DAMAGED_HEAD,
            DAMAGED_SPARE_LIST_CONTENT,
            DAMAGED_SPARE_GEN_CONTENT,

            // INTACT_HEAD,
            // INTACT_SPARE_LIST_CONTENT,
            // INTACT_SPARE_GEN_CONTENT,

            // NEARLY_DAMAGED_COMPONENT,
            // NON_DAMAGED_BUT_OLD_COMPONENT,
            // PLANT_CONDITION,
            // DUPLICATE_SPARES,
            // PAST_SPARE_PURCHASED,
            // IMPACT_ON_COST,
            COMMUNICATION_STARTER,
            OVERALL_PLANT_CONDITION,
            PAST_MATERIAL_PURCHASED,
            LOCAL_MATERIAL_FOUND,
            KEYPOINTS,
            IMPACT_ASSESSMENT_OF_PLANT,
            RECOMMENDED_LINE,
            FEEL_FREE_TO_CONNECT,
            GUN_MAINTENANCE_MANUAL,
            // GUN_MAINTENANCE_MANUAL_HEAD,
        } = LANGUAGES

        if (!emailText) {
            return ""
        }
        let e = emailText
        let final = ""
        if (e.includes(LANGUAGE_KEYS.COMMUNICATION_STARTER)) {
            final = e.replace(LANGUAGE_KEYS.COMMUNICATION_STARTER, COMMUNICATION_STARTER.content[0])
        }
        if (form.isDamagedComponentAvailable) {

            // if (e.includes(LANGUAGE_KEYS.DAMAGED_HEAD)) {
            //     final = final.replace(LANGUAGE_KEYS.DAMAGED_HEAD, DAMAGED_HEAD[0])
            // }
            if (selectedSpare.isDamagedComponentAvailable && selectedSpare.isDamagedComponentAvailable.length) {
                let str = this.makeSpareStringByList(selectedSpare.isDamagedComponentAvailable)

                if (e.includes(LANGUAGE_KEYS.DAMAGED_SPARE_LIST_CONTENT)) {
                    final = final.replace(LANGUAGE_KEYS.DAMAGED_SPARE_LIST_CONTENT, DAMAGED_SPARE_LIST_CONTENT[0])
                    final = final.replace(LANGUAGE_KEYS.SELECTED_DAMAGED_SPARE, str)
                }

                selectedSpare.isDamagedComponentAvailable.forEach((spareData, i)=>{
                    let spareStr = `${i+1}. ${spareData.label} - ${spareData.quantity} ${CONSTANTS.SPARE_UNIT_MAPPING[spareData.unit]} `
                    final = final.replace(LANGUAGE_KEYS[`SPARE_${i+1}`], spareStr)
                })
            } else {
                final = final.replace(LANGUAGE_KEYS.DAMAGED_SPARE_GEN_CONTENT, DAMAGED_SPARE_GEN_CONTENT[0])
            }
        }

        // if (form.isNearlyDamagedComponentAvailable) {

        //     if (e.includes(LANGUAGE_KEYS.INTACT_HEAD)) {
        //         final = final.replace(LANGUAGE_KEYS.INTACT_HEAD, INTACT_HEAD[0])
        //     }
        //     if (selectedSpare.isNearlyDamagedComponentAvailable && selectedSpare.isNearlyDamagedComponentAvailable.length) {
        //         let str = this.makeSpareStringByList(selectedSpare.isNearlyDamagedComponentAvailable)

        //         if (e.includes(LANGUAGE_KEYS.INTACT_SPARE_LIST_CONTENT)) {
        //             final = final.replace(LANGUAGE_KEYS.INTACT_SPARE_LIST_CONTENT, INTACT_SPARE_LIST_CONTENT[0])
        //             final = final.replace(LANGUAGE_KEYS.INTACTD_DAMAGED_SPARE, str)
        //         }
        //     } else{
        //         final = final.replace(LANGUAGE_KEYS.INTACT_SPARE_GEN_CONTENT, INTACT_SPARE_GEN_CONTENT[0])
        //     }
        // }


        if (e.includes(LANGUAGE_KEYS.OVERALL_PLANT_CONDITION_HEAD)) {
            final = final.replace(LANGUAGE_KEYS.COMMUNICATION_STARTER, OVERALL_PLANT_CONDITION.heading)
        }
        if (e.includes(LANGUAGE_KEYS.OVERALL_PLANT_CONDITION_OPERATIONAL) && form.isPlantRunning) {
            final = final.replace(LANGUAGE_KEYS.OVERALL_PLANT_CONDITION_OPERATIONAL, OVERALL_PLANT_CONDITION.OPERATIONAL.content[0])
        }
        if (e.includes(LANGUAGE_KEYS.OVERALL_PLANT_CONDITION_NON_OPERATIONAL) && !form.isPlantRunning) {
            final = final.replace(LANGUAGE_KEYS.OVERALL_PLANT_CONDITION_NON_OPERATIONAL, OVERALL_PLANT_CONDITION.NON_OPERATIONAL.content[0])
        }

        if (e.includes(LANGUAGE_KEYS.PAST_MATERIAL_PURCHASED_HEAD && form.isPastSparePurchaseNotDone)) {
            final = final.replace(LANGUAGE_KEYS.PAST_MATERIAL_PURCHASED_HEAD, PAST_MATERIAL_PURCHASED.heading)

            if (e.includes(LANGUAGE_KEYS.PAST_MATERIAL_PURCHASED_CONTENT)) {
                final = final.replace(LANGUAGE_KEYS.PAST_MATERIAL_PURCHASED_CONTENT, PAST_MATERIAL_PURCHASED.content[0])
            }
        }


        if (e.includes(LANGUAGE_KEYS.LOCAL_MATERIAL_FOUND_HEAD) && form.isUsingDuplicateSpares) {
            final = final.replace(LANGUAGE_KEYS.LOCAL_MATERIAL_FOUND_HEAD, LOCAL_MATERIAL_FOUND.heading)

            if (e.includes(LANGUAGE_KEYS.LOCAL_MATERIAL_FOUND_CONTENT)) {
                final = final.replace(LANGUAGE_KEYS.LOCAL_MATERIAL_FOUND_CONTENT, LOCAL_MATERIAL_FOUND.content[0])
            }
            // if (e.includes(LANGUAGE_KEYS.LOCAL_MATERIAL_FOUND_CONTENT_LIST)) {
            //     final = final.replace(LANGUAGE_KEYS.LOCAL_MATERIAL_FOUND_CONTENT_LIST, LOCAL_MATERIAL_FOUND.content[0])
            // }
        }


        if (e.includes(LANGUAGE_KEYS.KEYPOINTS_HEAD) && form.isGenTerms) {
            final = final.replace(LANGUAGE_KEYS.KEYPOINTS_HEAD, KEYPOINTS.heading)
            if (e.includes(LANGUAGE_KEYS.KEYPOINTS_1)) {
                final = final.replace(LANGUAGE_KEYS.KEYPOINTS_1, KEYPOINTS.content[0])
            }
            if (e.includes(LANGUAGE_KEYS.KEYPOINTS_2)) {
                final = final.replace(LANGUAGE_KEYS.KEYPOINTS_2, KEYPOINTS.content[1])
            }
            if (e.includes(LANGUAGE_KEYS.KEYPOINTS_3)) {
                final = final.replace(LANGUAGE_KEYS.KEYPOINTS_3, KEYPOINTS.content[2])
            }
            if (e.includes(LANGUAGE_KEYS.KEYPOINTS_4)) {
                final = final.replace(LANGUAGE_KEYS.KEYPOINTS_4, KEYPOINTS.content[3])
            }
            if (e.includes(LANGUAGE_KEYS.KEYPOINTS_5)) {
                final = final.replace(LANGUAGE_KEYS.KEYPOINTS_5, KEYPOINTS.content[4])
            }
            if (e.includes(LANGUAGE_KEYS.KEYPOINTS_6)) {
                final = final.replace(LANGUAGE_KEYS.KEYPOINTS_6, KEYPOINTS.content[5])
            }
        }

        if (e.includes(LANGUAGE_KEYS.IMPACT_ASSESSMENT_OF_PLANT_HEAD) && form.isCostOnImpact) {
            final = final.replace(LANGUAGE_KEYS.IMPACT_ASSESSMENT_OF_PLANT_HEAD, IMPACT_ASSESSMENT_OF_PLANT.heading)

            if (e.includes(LANGUAGE_KEYS.IMPACT_ASSESSMENT_OF_PLANT_CONTENT)) {
                final = final.replace(LANGUAGE_KEYS.IMPACT_ASSESSMENT_OF_PLANT_CONTENT, IMPACT_ASSESSMENT_OF_PLANT.content[0])
            }
        }

        if (e.includes(LANGUAGE_KEYS.RECOMMENDED_LINE)) {
            final = final.replace(LANGUAGE_KEYS.RECOMMENDED_LINE, RECOMMENDED_LINE.content[0])
        }

        if (e.includes(LANGUAGE_KEYS.GUN_MAINTENANCE_MANUAL)) {
            final = final.replace(LANGUAGE_KEYS.GUN_MAINTENANCE_MANUAL_HEAD, GUN_MAINTENANCE_MANUAL.heading)
            final = final.replace(LANGUAGE_KEYS.GUN_MAINTENANCE_MANUAL, GUN_MAINTENANCE_MANUAL.content[0])
        }

        if (e.includes(LANGUAGE_KEYS.FEEL_FREE_TO_CONNECT)) {
            final = final.replace(LANGUAGE_KEYS.FEEL_FREE_TO_CONNECT, FEEL_FREE_TO_CONNECT.content[0])
        }
        if (user.full_name) {
            final = final.replace(LANGUAGE_KEYS.ENGINEER_NAME, user.full_name)
        }
        if (user.designation) {
            final = final.replace(LANGUAGE_KEYS.ENGINEER_DESIGNATION, user.designation)
        }
        if (user.contact_number) {
            final = final.replace(LANGUAGE_KEYS.ENGINEER_CONTACT_NUMBER, "Mob: +91-" + user.contact_number)
        }
        if (user.email) {
            final = final.replace(LANGUAGE_KEYS.ENGINEER_OFFICAIL_EMAIL, "Email: " + user.email)
        }



        return final


    },
    removeEmailContectkeys(content) {
        const { LANGUAGE_KEYS } = emailConfig
        let old = content
        // let final = ""
        Object.keys(LANGUAGE_KEYS).forEach(key => {
            if (content.includes(key)) {
                old = old.replace(key, "")
            }
        })

        return old.replace(/\n{2,}/g, '\n\n') // removing spaces
    },
    makeSpareStringByList(arr) {
        let str = ""
        for (let i = 0; i < arr.length; i++) {
            if (i === (arr.length - 1)) {
                str = str + arr[i].label + " "
            } else if (i === ((arr.length - 2))) {
                str = str + arr[i].label + " and "
            } else {
                str = str + arr[i].label + ", "
            }
        }
        return str
    },
    createServiceAPI(form, spare){
        const {client} = form
        let u = localStorage.getItem('user');
        if (u) {
            u = JSON.parse(u);
        }
        let payload = {     
            client_name: client.client_name, // Client Name
            client_id:client.client_id, // Unique Client ID  mongo
            client_code:client.client_code, // Unique Client ID 
        
            service_mode:form.serviceMode, // phone, video call, physical
            service_initiation_request:form.initiation, // complain, randon-visit
        
            date_of_service: form.serviceDate, // Date of Service written in BOOK
            is_quotation_required:spare.isDamagedComponentAvailable && spare.isDamagedComponentAvailable.length?true:false, // Status
            // is_quotation_sent:true, // Status
            // is_order_placed:true, // Status
            // primary_quotation_date:"01-Apr-2000", // First Quotation Send ON for this service 
            // is_service_lock:false, // no changes will be done if order is placed
        
            // quotation_revisions:[ 
            //     {
            //         date:"", // First Quotation Send ON for this service will be added in this as well
            //         id:"fdsfsdgdfgfdgdf",
            //         sn:1
            //     },
            //     {
            //         date:"", // next quotation if available
            //         id:"fdsfsdgdfgfdgdf",
            //         sn:2
            //     },
            // ],
            service_book_number:form.serviceBookNo, // Service Book Number written in Book
            service_book_url:"",
            service_explanation:"",
            // available_client_employee: [
            //     {
            //         contact_person_name: "Dorsey Hayden Trading",
            //         contact_person_designation: "Durham Hensley LLC",
            //         contact_person_phone: "Sims and Gates Trading",
            //         contact_person_email: "rytecamoma@mailinator.com",
            //     }
            // ],
        
            service_engineer_name: u.full_name,
            service_engineer_employee_id: u.employee_id,
            // service_engineer_contact_number: "530",
            // service_engineer_email: "sygymodi@mailinator.com",
            damaged_components:spare.isDamagedComponentAvailable, //array of components
            recommended_components:spare.isRecommendedComponentAvailable, //array of components
        
            source:"",
            sub_source:"",
            medium:"",
        
        }
        if(Object.keys(form).includes("isManual")){
            payload.is_automatic = !form.isManual
        }

        API.saveServiceByMailTool(payload).then((res)=>{
            console.log(res)
        }).catch((err)=> console.log(err))
    }
    // delBlankLines(emailContent) {
    //     var stringArray = emailContent.split('\n');
    //     var temp = [""];
    //     var x = 0;

    //     for (var i = 0; i < stringArray.length; i++) {
    //         if (stringArray[i].trim() != "") {
    //             temp[x] = stringArray[i];
    //             x++;
    //         }
    //     }

    //     temp = temp.join('\n');
    //     return temp;
    // },
}



export default emailModals